import { CategoryModel } from '@/ApiTypes.ts';
import { BuildType } from '@/services/ApiService.ts';

export const categoryApiEndpoints = (build: BuildType) => ({
    getAllCategories: build.query<CategoryModel[], void>({
        query: () => 'categories',
        transformResponse: (response: CategoryModel[]) => response,
    }),
});
